module.exports = __webpack_public_path__ + "static/logo.workable-d84cf7a9159c9f3ffaa756df97b1b720.svg";